/**
 * 「개발 중 · 정식 서비스 아님」 안내를 언제 띄울지.
 *
 * 화면과 분리해 둔 이유: 날짜 경계(자정)와 저장소가 막힌 브라우저를 시험으로 지키기 위해서다.
 * 저장소(localStorage)가 막히면 — 사생활 보호 창, 차단된 사이트 데이터 — 안내는 늘 뜬다.
 * 숨기지 못해서 생기는 불편이, 안내를 못 보는 것보다 낫다.
 */

export const DEV_NOTICE_KEY = 'lastroll.devNotice.hiddenOn';

/**
 * 예상 개발 완료일 (소유자 지정, 2026-10-19). 일정이 바뀌면 여기와 아래 영어 표기를 함께 고친다.
 * ISO 날짜로 두고 표기는 함수가 만든다 — 한 곳에서 고치면 한국어·영어가 같이 바뀐다.
 */
export const DEV_NOTICE_ETA = '2026-11-15';

const EN_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** 'YYYY-MM-DD' → '2026년 11월 15일' */
export function etaKo(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  return `${y}년 ${m}월 ${d}일`;
}

/** 'YYYY-MM-DD' → 'Nov 15, 2026' */
export function etaEn(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  return `${EN_MONTHS[m! - 1]} ${d}, ${y}`;
}

/** 로컬 날짜 YYYY-MM-DD. 「오늘 하루」는 보는 사람의 하루다. */
export function localDay(d: Date): string {
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** 「오늘 하루 보지 않기」를 누른 날이 오늘이 아니면 띄운다. */
export function shouldShowDevNotice(hiddenOn: string | null, today: string): boolean {
  return hiddenOn !== today;
}

export function readHiddenOn(): string | null {
  try {
    return window.localStorage.getItem(DEV_NOTICE_KEY);
  } catch {
    return null;
  }
}

export function writeHiddenOn(day: string): void {
  try {
    window.localStorage.setItem(DEV_NOTICE_KEY, day);
  } catch {
    // 저장소가 막힌 브라우저 — 다음 방문에 다시 뜬다. 그래도 된다.
  }
}
